module.exports = __webpack_public_path__ + "static/media/icono_guardados.f30d4d60.svg";